module.exports = __webpack_public_path__ + "img/icon2.fa44dac4.png";